import { useRouteRef } from '@backstage/core-plugin-api';
import catalogPlugin from '@backstage/plugin-catalog/alpha';

/**
 * Where the back link and the not-found panel lead: the catalog index,
 * resolved through its route ref as the stock context menu does (code O12),
 * so a different mount path follows the app's routing.
 */
export function useCatalogRootPath(): string {
  return useRouteRef(catalogPlugin.routes.catalogIndex)();
}
